// extracted by mini-css-extract-plugin
export default {"content":"SweepingPayments_content__AKuoU zb-container","tppHeader":"SweepingPayments_tppHeader__FWXqI"};